import PropTypes from 'prop-types'

import { EMPTY_PLACEHOLDER } from '../constants'

const treeOptionPropType = PropTypes.shape({
  label: PropTypes.string,
  value: PropTypes.string.isRequired,
  disabled: PropTypes.bool,
})

treeOptionPropType.defaultProps = {
  label: EMPTY_PLACEHOLDER,
  disabled: false,
}

treeOptionPropType.children = PropTypes.arrayOf(treeOptionPropType)

export default treeOptionPropType
